export const PAGE_STATE = {
    PRE_LOADING: "preloading",
    LOADING: "loading",
    PAGE_READY: "ready",
}

export const PAGE_STATE_MESSAGE_MAP = {
    [PAGE_STATE.LOADING]: "",
    [PAGE_STATE.PRE_LOADING]: "",
}

export const COMMON_LOADING_STATES = { 
    FILTER_LOADING: "FILTER_LOADING",
    FILTER_READY: "FILTER_READY",
    GRID_LOADING: "GRID_LOADING",
    GRID_READY: "GRID_READY",
    GENERAL_LOADING: "GENERAL_LOADING",
    GENERAL_READY: "GENERAL_READY",
}

export const COMMON_LOADING_STATES_MESSAGE_MAP = {
    [COMMON_LOADING_STATES.FILTER_LOADING]: "Filters Loading...",
    [COMMON_LOADING_STATES.FILTER_READY]: "Filters Ready",
    [COMMON_LOADING_STATES.GRID_LOADING]: "Grid Data Loading...",
    [COMMON_LOADING_STATES.GRID_READY]: "Grid Ready",
    [COMMON_LOADING_STATES.GENERAL_LOADING]: "",
    [COMMON_LOADING_STATES.GENERAL_READY]: "",
}

export const COMMON_EXPORTING_STATES = {
    EXPORT_LOADING: "EXPORT_LOADING",
    EXPORT_READY: "EXPORT_READY",   
}

export const COMMON_EXPORTING_STATES_MESSAGE_MAP = {
    [COMMON_EXPORTING_STATES.EXPORT_LOADING]: "Exporting File...",
    [COMMON_EXPORTING_STATES.EXPORT_READY]: "File Ready",
}

export const ACTIVITY_LOGS_LOADING_STATES = {
    GRID_LOADING: "GRID_LOADING",
    GRID_READY: "GRID_READY",
    DETAIL_LOADING: "DETAIL_LOADING",
    DETAIL_READY: "DETAIL_READY",
}

export const ACTIVITY_LOGS_LOADING_STATES_MESSAGE_MAP = {
    [ACTIVITY_LOGS_LOADING_STATES.DETAIL_LOADING]: "Loading Details...",
    [ACTIVITY_LOGS_LOADING_STATES.DETAIL_READY]: "Details Ready",
    [ACTIVITY_LOGS_LOADING_STATES.GRID_LOADING]: "Loading Grid Data...",
    [ACTIVITY_LOGS_LOADING_STATES.GRID_READY]: "Grid Ready",
}

export const API_HUB_LOADING_STATES = {
    DETAIL_LOADING: "DETAIL_LOADING",
    DETAIL_READY: "DETAIL_READY",
    DISABLE_API_LOADING: "DISABLE_API_LOADING",
    DISABLE_API_READY: "DISABLE_API_READY",
    REQUEST_PROD_KEY_LOADING: "REQUEST_PROD_KEY_LOADING",
    REQUEST_PROD_KEY_READY: "REQUEST_PROD_KEY_READY",
}

export const API_HUB_LOADING_STATES_MESSAGE_MAP = {
    [API_HUB_LOADING_STATES.DETAIL_LOADING]: "Loading Details...",
    [ACTIVITY_LOGS_LOADING_STATES.DETAIL_READY]: "Details Ready",
    [API_HUB_LOADING_STATES.DISABLE_API_LOADING]: "",
    [API_HUB_LOADING_STATES.REQUEST_PROD_KEY_LOADING]: "",
}

export const PLAN_LOADING_STATES = {
    PLANS_LOADING: "PLANS_LOADING",
    PLANS_READY: "PLANS_READY",
}

export const PLAN_LOADING_STATES_MESSAGE_MAP = {
    [PLAN_LOADING_STATES.PLANS_LOADING]: "Loading Plans...",
    [PLAN_LOADING_STATES.PLANS_READY]: "Plans Ready",
}

export const ENDPOINT_RESULT_TYPE = {
    ERROR: "error",
    SUCCESS: "success",
    WARNING: "warning",
}

export const SYSTEM = {
    DATE_FORMAT: "MM/dd/yyyy",
}

export const RESTRICT_SPACE_AND_SPECIAL_CHARACTERES_REGEX = /^[a-zA-Z0-9]*$/
export const SPACE_NOT_ALLOWED_IN_CLIENT_ID_TEXT = "Special characters and Spaces are not allowed in Client ID"
export const SPACE_NOT_ALLOWED_IN_RECIPIENT_CLIENT_ID_TEXT = "Special characters and spaces are not allowed in Recipient Client ID"

export const SPACE_AND_SPECIAL_CHARACTERS_NOT_ALLOWED_TEXT = "Special characters and Spaces are not allowed"

export const PARAMETER_FOR_APP_SWITCH_REDIRECT_URL = {
    IMPORT: 'import',
}

export const TERMS_AND_CONDITIONS_LINK = "https://www.tax1099.com/saas-terms-and-conditions"

export const ENVIRONMENTS = {
    DEV: 'DEV',
    STAGE: 'STAGE',
    PROD: 'PROD',
}

export const USER_SECTION_ROUTES = {
    USERS: "users",
    MANAGE_USERS: "manageusers"
}

export const FORM_NAMES = {
    FORM1042S: "Form1042S",
    FORM1095B: "Form1095B",
}

export const FORM_IDS = {
    $1095C: 30,
    8809: 0,
    $1099NEC: 47,
    $1099MISC: 1,
}

export const INTEGRATION_ROUTES = {
    XERO: "xero",
    FRESHBOOKS: "freshbooks",
    IMPORT: "import",
    FORMS: "forms",
    CALLBACK_URL_INDEX_KEYWORD: "index.html",
    CALLBACK_URL_INDEX2_KEYWORD: "index",
    QBO: "qbo",
    SAGE: "sageintacct",
    NETSUITE: "netsuite",
    QBD: "qbd",
    WEB_CONNECTOR: "webconnector",
    PLUGIN: "plugin",
    WEB_CONNECTOR_3_0: "webconnector3.0",
    EXCEL_IMPORT: "excelimport",
    ZOHO: "zoho",
    TIPALTI: "tipalti",
    BILL: "bill",
    ENTRATA: "entrata",
    ACCOUNTINGSUITE: "accountingsuite",
}

export const MANAGE_BOI_ROUTES = {
    BOI_REPORTING: "boireporting",
    FILE_BOI: "fileboi",
}

export const FORM_TYPE = {
    FORM_BOI: "FormBOI",
    
}
export const GENERIC_ERROR_MESSAGE = "Facing some error. Please try again or contact support"

export const API_SECTION_ROUTES = {
    API: "api",
}

export const BOI_REPORTING_SECTION_ROUTES = {
    BOIREPORTING: "boireporting",
}

export const NOTICE_SECTION_ROUTES = {
    NOTICE: "notices",
}
export const PRE_LOGIN_ROUTES = {
    SIGNIN: "signin"
}

export const ACCOUNT_SECTION_ROUTES = {
    ACCOUNT_TEXT: "account",
    GENERAL_TEXT: "general"
}
